import { css } from '@emotion/css';
import { cssObj } from '@/css/resources/functions.css';
import { transitions } from '@/css/resources/variables.css';
import {
	expandLink,
	fluidPadding,
	fluidBorderRadius,
	fluidBorderWidth,
} from '@/css/resources/mixins.css';

const getDynamicStyles = (styles) =>
	cssObj(
		fluidPadding(styles?.padding),
		fluidBorderWidth(styles?.border?.width),
		fluidBorderRadius(styles?.border?.radius),
		{
			width:
				styles?.minWidth &&
				styles?.maxWidth &&
				`clamp(${styles?.minWidth}, 100%, ${styles?.maxWidth})`,
			background: styles?.backgroundColor,
			borderColor: styles?.border?.color,
		}
	);

const getStyles = (styles) =>
	css(getDynamicStyles(styles), {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		borderStyle: 'solid',
		overflow: 'hidden',

		'.supt-cardLogo__image': {
			display: 'block',
			maxWidth: '100%',
		},

		/* with link */
		'&.supt-withLink': cssObj(expandLink(), {
			transition: `all ${transitions.mid} ease-out`,

			'&:hover, &:focus-within': getDynamicStyles(styles?.states?.hover),
		}),
	});

const getEditGlobalStyles = (styles) =>
	cssObj({
		'.wp-block[data-type="supt/card-logo"]': {
			width:
				styles?.minWidth &&
				styles?.maxWidth &&
				`clamp(${styles?.minWidth}, 100%, ${styles?.maxWidth})`,
		},
	});

export { getStyles, getEditGlobalStyles };
